import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { useClientContext } from "../../context/ClientContext";

const ClientDashboardX = lazy(() => import("./ClientDashboardX"));

// Your routes
const CLIDASH_X_ROUTES: RouteObject[] = [
  {
    path: `/private/users-summary/:clientType`, // Use a placeholder for clientType
    element: React.createElement(ClientDashboardX),
  },
];

// Define a functional component
const ClientDashboardRoutes = () => {
  const { clientType, updateClientType } = useClientContext();

  // Update the path dynamically
  CLIDASH_X_ROUTES[0].path = `/private/users-summary/${clientType}`;

  return CLIDASH_X_ROUTES;
};

export default ClientDashboardRoutes;
export { CLIDASH_X_ROUTES };
